import { Assets, Rectangle, Texture } from 'pixi.js';

/**
 * @param {string} basePath e.g. `/assets/spritesheet/fire_sprite`
 * @returns {Promise<object>}
 */
async function fetchSpritesheetJson(basePath) {
  const r = await fetch(`${basePath}.json`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  const text = await r.text();
  const trimmed = text.trimStart();
  if (!trimmed || trimmed.startsWith('<')) {
    throw new Error(`Missing spritesheet JSON at ${basePath}.json`);
  }
  try {
    return JSON.parse(text);
  } catch (err) {
    throw new Error(`Invalid spritesheet JSON at ${basePath}.json: ${err.message}`);
  }
}

/**
 * @param {string} basePath e.g. `/assets/spritesheet/fire_sprite`
 * @returns {Promise<import('pixi.js').Texture[]>}
 */
export async function loadSpritesheetFrames(basePath) {
  const [sheetTex, json] = await Promise.all([
    Assets.load(`${basePath}.png`),
    fetchSpritesheetJson(basePath),
  ]);

  const frames = Object.values(json.frames ?? {})
    .map((entry) => entry.frame)
    .filter((f) => f && f.w > 0 && f.h > 0)
    .sort((a, b) => a.y - b.y || a.x - b.x);

  if (!frames.length) return [];

  const source = sheetTex.source ?? sheetTex;
  return frames.map(
    (f) =>
      new Texture({
        source,
        frame: new Rectangle(f.x, f.y, f.w, f.h),
      }),
  );
}
